import { Badge, Box, Flex, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import dayjs from "dayjs";
import { Popover } from "../../../components/Popover";
import { COLORS } from "../../../constants/colors";

const statusStyles = {
  pending: { bg: "#FFF3CD", color: "#856404", label: "Pending" },
  in: { bg: "#D4EDDA", color: "#155724", label: "Checked In" },
  out: { bg: "#F8D7DA", color: "#721C24", label: "Checked Out" },
};

const StatusBadge = ({ status }) => {
  const normalizedStatus = status?.toLowerCase()?.trim() || "pending";
  const style = statusStyles[normalizedStatus] || statusStyles.pending;

  return (
    <Badge
      px="10px"
      py="3px"
      borderRadius="full"
      fontSize="0.65rem"
      fontWeight="600"
      bg={style.bg}
      color={style.color}
    >
      {style.label}
    </Badge>
  );
};

const SingleGuest = (props) => {
  const { name, endDate, allowCompany, status } = props;

  const cardBg = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const appTextColor = useColorModeValue(COLORS.primary, COLORS.primary);

  return (
    <Box
      p="1rem"
      borderRadius="10px"
      boxShadow="sm"
      bg={cardBg}
      color={appTextColor}
      mb="2rem"
    >
      <Flex justify="space-between" align="center">
        {/*<Avatar name='Kent Dodds' src='https://bit.ly/kent-c-dodds' />*/}

        <Stack fontSize="0.8rem">
          <Flex align="center" gap="8px">
            <Text fontSize="1.1rem" fontWeight="semibold" color={COLORS.black}>
              {name}
            </Text>
            
          </Flex>
          <Text>Last day of visit {dayjs(endDate).format("DD/MMM/YYYY")}</Text>
          <Text m="0 !important">
            {allowCompany ? "With Company" : "Without Company"}
          </Text>
        </Stack>
        
        <Stack alignSelf={"flex-end"} align="flex-end" spacing="2rem">
          <StatusBadge status={status} />
          <Popover {...props} />
        </Stack>
      </Flex>
    </Box>
  );
};

export default SingleGuest;